<script>
import _ from 'lodash'

export default {
  props: {
    label: { type: String, default: null },
    rules: { type: [String, Object], default: '' },
    labelFor: { type: String, default: null },
  },
  computed: {
    vid() {
      return _.camelCase(_.lowerCase(this.label))
    },
    name() {
      return _.lowerCase(this.label)
    },
  },
}
</script>

<template>
  <ValidationProvider
    v-slot="{ errors, validate }"
    tag="div"
    class="px-3 mb-6 w-full"
    :name="name"
    :vid="vid"
    :rules="rules"
  >
    <label v-if="label" class="label" :for="labelFor">
      {{ label }}
    </label>
    <slot :errors="errors" :validate="validate" />
    <p v-if="errors.length" class="text-red-500 text-xs italic mt-2">
      {{ errors[0] }}
    </p>
  </ValidationProvider>
</template>
